/**
 * Date format helpers for German locale (DD.MM.YYYY) <-> ISO (YYYY-MM-DD).
 * API always uses ISO, UI displays German format.
 */

export function isoToGerman(iso: string | null | undefined): string {
  if (!iso) return '';
  // Accept YYYY-MM-DD or YYYY-MM-DDTHH:mm:ss...
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return '';
  return `${m[3]}.${m[2]}.${m[1]}`;
}

export function germanToIso(de: string | null | undefined): string {
  if (!de) return '';
  const m = de.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
  if (!m) return '';
  const day = m[1].padStart(2, '0');
  const month = m[2].padStart(2, '0');
  return `${m[3]}-${month}-${day}`;
}
